/** 홍보 영상 검수 화면 (pages/todaymall/promoVideo). */
export default {
  'pages.promoVideo.title': "홍보 영상 검수",
  'pages.promoVideo.hint': "영상을 끝까지 보고 상품의 모양·색·로고가 원본 사진과 같은지 확인한 뒤 승인하세요. 승인한 영상만 상품 공유에 붙습니다.",
  'pages.promoVideo.health.ok': "영상 서버 정상",
  'pages.promoVideo.health.degraded': "영상 서버 이상",
  'pages.promoVideo.health.off': "기능 꺼짐",
  'pages.promoVideo.health.queue': "대기 {n}건",
  'pages.promoVideo.tab.review': "검수 대기",
  'pages.promoVideo.tab.approved': "승인됨",
  'pages.promoVideo.tab.making': "만드는 중",
  'pages.promoVideo.tab.failed': "실패",
  'pages.promoVideo.tab.rejected': "반려됨",
  'pages.promoVideo.tab.all': "전체",
  'pages.promoVideo.status.queued': "대기열",
  'pages.promoVideo.status.generating': "만드는 중",
  'pages.promoVideo.status.review': "검수 대기",
  'pages.promoVideo.status.approved': "승인됨",
  'pages.promoVideo.status.rejected': "반려됨",
  'pages.promoVideo.status.failed': "실패",
  'pages.promoVideo.col.poster': "영상",
  'pages.promoVideo.col.product': "상품",
  'pages.promoVideo.col.source': "출처",
  'pages.promoVideo.col.status': "상태",
  'pages.promoVideo.col.price': "가격",
  'pages.promoVideo.col.requests': "공유 요청",
  'pages.promoVideo.col.updated': "갱신",
  'pages.promoVideo.action.view': "보기",
  'pages.promoVideo.action.approve': "승인",
  'pages.promoVideo.action.reject': "반려",
  'pages.promoVideo.action.regenerate': "사진 골라 다시 만들기",
  'pages.promoVideo.action.recompose': "문구만 다시 그리기",
  'pages.promoVideo.action.request': "상품 지정해 만들기",
  'pages.promoVideo.action.openProduct': "상품 페이지",
  'pages.promoVideo.action.search': "검색",
  'pages.promoVideo.action.refresh': "새로고침",
  'pages.promoVideo.reject.reason': "반려 사유(선택)",
  'pages.promoVideo.detail.title': "영상 속 상품명",
  'pages.promoVideo.detail.captions': "자막(컷마다 하나)",
  'pages.promoVideo.detail.price': "판매가(원)",
  'pages.promoVideo.detail.tagPrice': "정가(원, 할인율 표시용)",
  'pages.promoVideo.detail.photos': "AI 컷에 쓸 사진을 고르세요(설명 그림·사양표는 빼는 것이 좋습니다)",
  'pages.promoVideo.detail.photoAi': "AI 사용",
  'pages.promoVideo.detail.photoInfographic': "설명 그림",
  'pages.promoVideo.detail.shots': "쓰인 컷",
  'pages.promoVideo.detail.shotClip': "AI 컷",
  'pages.promoVideo.detail.shotImage': "사진 확대",
  'pages.promoVideo.detail.qc': "원본 유사도",
  'pages.promoVideo.detail.music': "배경음악",
  'pages.promoVideo.detail.lastError': "오류",
  'pages.promoVideo.detail.progress': "진행",
  'pages.promoVideo.detail.noVideo': "아직 영상이 없습니다.",
  'pages.promoVideo.detail.recomposeHint': "문구만 다시 그리기는 GPU 를 쓰지 않아 10초쯤 걸립니다. 컷이 마음에 들지 않으면 사진을 골라 다시 만드세요(3분쯤).",
  'pages.promoVideo.msg.approved': "승인했습니다. 이제 공유에 영상 링크가 붙습니다.",
  'pages.promoVideo.msg.rejected': "반려했습니다.",
  'pages.promoVideo.msg.regenerating': "다시 만들기 시작했습니다. 3분쯤 걸립니다.",
  'pages.promoVideo.msg.recomposed': "문구를 다시 그렸습니다.",
  'pages.promoVideo.msg.requested': "만들기를 요청했습니다.",
  'pages.promoVideo.msg.pickPhoto': "사진을 하나 이상 고르세요.",
  'pages.promoVideo.form.source': "출처",
  'pages.promoVideo.form.productId': "상품 번호",
  'pages.promoVideo.form.search': "상품명 또는 번호",
  'pages.promoVideo.form.link': "상품 링크",
  'pages.promoVideo.form.linkPlaceholder': "https://detail.1688.com/offer/….html",
  'pages.promoVideo.form.linkHelp': "1688·타오바오(티몰)·VVIC 상품 주소나 투데이몰 상품 주소·공유 주소를 붙여 넣으세요. 단축 주소는 열어서 나온 주소를 넣어야 합니다.",
  'pages.promoVideo.form.linkRequired': "상품 링크를 붙여 넣어 주세요.",
};
